import { EVENT } from "../constants/eventNames";
import { ATTACK_SETTING_NAMES } from "../constants/gameAttackConstants";
import TimeKeeper from "../engine/TimeKeeper";
import EventBus from "../lib/EventBus";
import AttackController from "./AttackController";
import Attack from "./Attacks";

class SybilAttack extends Attack {
	constructor(startTimestamp) {
		super(startTimestamp);
		
		/**
		 * The sybil nodes that is owned by the main node
		 * 
		 * @property sybilNodes
		 * @type {Array}
		 */
		this.sybilNodes = [];

		/**
		 * Local reference to the event bus
		 * 
		 * @property _eventBus
		 * @type {EventBus}
		 */
		this._eventBus = EventBus;

		/**
		 * The time when the nodes are spawned
		 * 
		 * @property spawnTime
		 * @type {number}
		 */
		this.spawnTime = TimeKeeper.accumulatedDeltaTime + 10; // Is set to 10 to make the nodes spawn 10 seconds after the main node has spawned.

		/**
		 * The time when the nodes are spawned.
		 * 
		 * Used to keep track to remove the nodes.
		 * 
		 * @property spawnTimeStamp
		 * @type {number}
		 */
		this.spawnTimeStamp = 0; 

		/**
		 * Used to keep track if we should stop spawning nodes
		 * 
		 * @property attackOver
		 * @type {boolean}
		 */
		this.attackOver = false;

		/**
		 * Keep track if nodes have spawned
		 * 
		 * @property nodeHasSpawned
		 * @type {boolean}
		 * 
		 */
		this.nodeHasSpawned = false;
		
		this.init();
	}

	/**
	 * How long the nodes are active
	 * 
	 * @property activeTime
	 * @type {number}
	 */
	get activeTime() {
		return AttackController.getAttackOption(ATTACK_SETTING_NAMES.ACTIVE_TIME_FOR_SYBIL);
	}

	/**
	 * The minimum time between the nodes are spawned
	 * 
	 * @property minSpawnTime
	 * @type {number}
	 */
	get minSpawnTime() {
		return AttackController.getAttackOption(ATTACK_SETTING_NAMES.MIN_SPAWN_TIME_FOR_SYBIL);
	}

	
	/**
	 * The maximum time between the nodes are spawned
	 * 
	 * @property maxSpawnTime
	 * @type {number}
	 */
	get maxSpawnTime() {
		return AttackController.getAttackOption(ATTACK_SETTING_NAMES.MAX_SPAWN_TIME_FOR_SYBIL);
	}
	
	init() {
		// This line must be at the top
		super.init();
		// Initilization paramters

		// Limit the number of main sybil nodes, currently it is set to 3 - done
		// Apply the sybil attack to a new aircraft - this is done in the attack controller
		// In random intervals the sybil aircraft will create flooding aircraft - done
		// The flooding aircraft is aircraft with stolen identities - done
		// The new flooding is added to the sybilNodes array - done
		// After a while the nodes are removed from the simulation - done
		// When it is on its way to the final waypoint, no nodes can be created and if nodes exist they are removed - done


	}

	update(aircraftModel) {
		if (this.attackOver) {
			return;
		}

		const currentTime = TimeKeeper.accumulatedDeltaTime;

		const lastWaypoint = aircraftModel.fms.waypoints[aircraftModel.fms.waypoints.length - 1];
        const currentWaypoint = aircraftModel.fms.currentWaypoint;

		if (lastWaypoint === currentWaypoint) {
			// Remove all the sybil nodes
			this.removeSybilNode();
			this.attackOver = true;
			return;
		}

		if (((this.spawnTimeStamp + this.activeTime) < currentTime) && this.nodeHasSpawned) {
			// Remove the sybil nodes
			this.removeSybilNode();
			this.nodeHasSpawned = false;
			return;
		}

		if ((currentTime > this.spawnTime) && !this.nodeHasSpawned) {
			// Create a new sybil node
			this._eventBus.trigger(EVENT.SPAWN_SYBIL_NODES, aircraftModel);
			// Set the next spawn time
			this.spawnTime = currentTime + Math.floor(Math.random() * (this.maxSpawnTime - this.minSpawnTime + 1)) + this.minSpawnTime;
			// Set the spawn timestamp
			this.spawnTimeStamp = currentTime;
			// Set the node has spawned to true
			this.nodeHasSpawned = true;
		}


	}
	
	end(endTimestamp) {
		// This must be the first line
		super.end(endTimestamp);
		// Operations to run at the end of the attack
	}

	removeSybilNode() {
		this.sybilNodes.forEach(node => {
			this._eventBus.trigger(EVENT.REMOVE_AIRCRAFT, node);
		});
		this.sybilNodes = [];
	}
}

export default SybilAttack;